import { InitialState, State } from '../types';

const getSectionIndex = (state: InitialState) => state.sectionIndex;

const getPrevSectionIndex = (state: InitialState) => state.prevSectionIndex;

const getSubNavHeight = (state: InitialState) => state.subNavHeight;

const getWidth = (state: InitialState) => state.width;

const getHeight = (state: InitialState) => state.height;

const getIsShort = (state: InitialState) => {
  const height = getHeight(state);
  return height === 'short';
};

/**
 * We don't want to render the animations until the viewport size is known to avoid rendering
 * and then immediately unmounting a set of animations if getIsAnimationScrollable
 * returns false due to width being undefined.
 * */
const getIsViewportSizeKnown = (state: InitialState) => {
  const width = getWidth(state);
  return width !== undefined;
};
const getIsAnimationScrollable = (state: InitialState) => {
  const width = getWidth(state);

  return width === 'small' || width === 'medium' || width === 'extraSmall';
};

const getUniversalNavHeight = (state: InitialState) => {
  const width = getWidth(state);
  return width === 'extraSmall' ? 60 : 70;
};

const getTextRootMargin = (state: InitialState) => {
  const isShort = getIsShort(state);
  const isAnimationScrollable = getIsAnimationScrollable(state);
  const subNavHeight = getSubNavHeight(state);
  const universalNavHeight = getUniversalNavHeight(state);

  const topMargin =
    isShort || isAnimationScrollable
      ? -100
      : -subNavHeight - universalNavHeight - 10;

  return `${topMargin}px 0px -125px 0px `;
};

const getAnimationRootMargin = (state: InitialState) => {
  const isShort = getIsShort(state);
  const subNavHeight = getSubNavHeight(state);
  const topMargin = isShort ? -10 : -subNavHeight;
  const bottomMargin = isShort ? -10 : -100;
  return `${topMargin}px 0px ${bottomMargin}px 0px `;
};

export const mapStateToProps = (state: InitialState): State => ({
  animationRootMargin: getAnimationRootMargin(state),
  isViewportSizeKnown: getIsViewportSizeKnown(state),
  height: getHeight(state),
  isAnimationScrollable: getIsAnimationScrollable(state),
  prevSectionIndex: getPrevSectionIndex(state),
  sectionIndex: getSectionIndex(state),
  subNavHeight: getSubNavHeight(state),
  textRootMargin: getTextRootMargin(state),
  universalNavHeight: getUniversalNavHeight(state),
  width: getWidth(state),
});
